import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Nav, Navbar, Offcanvas, NavDropdown, Button, ListGroup, Image, Badge, FormControl, InputGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { logoutUser, loggedUser } from "../../../redux/authSlice";
import { getCartItems, removeItemFromCart } from "../../../redux/cartSlice"; //
import { searchProducts } from "../../../redux/productSlice";

import { Link, useNavigate, NavLink } from 'react-router-dom';
import { FaUserCircle, FaShoppingCart, FaTrashAlt, FaCog, FaSearch, FaUser, FaHeart, FaShoppingBag } from 'react-icons/fa';
import { toast } from "react-toastify";
import CheckoutSteps from "../CheckoutSteps/CheckoutSteps";

const Header = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { user = {}, error, message, loading } = useSelector((state) => state.auth || {});
  const { cartItems } = useSelector((state) => state.cart);  // ✅ Fetch cartItems from Redux
  const cartCount = cartItems?.length;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  if (process.env.NODE_ENV === "development") {
    console.log("cartCount++++refresh", cartItems?.length, cartCount);
    console.log("user++++", user?.name, error)
    console.log("searchQuery", searchQuery);
  }
  const handleSearchSumbit = e => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // dispatch(searchProducts(searchQuery));
      // navigate(`/search?keyword=${encodeURIComponent(searchQuery.trim())}`);
      navigate(`/search?keyword=${searchQuery.trim()}`);
    }
    // else {
    //   navigate(`/search`);
    // }
    setSearchQuery("");
  };
  // 🔹 Logout Button Handler
  const handleLogout = async () => {
    await dispatch(logoutUser()).then((res) => {
      localStorage.clear();
      navigate("/");
    }).catch((error) => toast.error(error));
    toast.success("Logged out successfully.");
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch(loggedUser(token));
    }
    // if (cartCount === cartItems?.length) {
    //   dispatch(getCartItems()) // ✅ Fetch cart items
    // }
    dispatch(getCartItems())
  }, [dispatch, cartCount]);

  const navLinks = [
    { path: '/', label: 'Home' },
    {
      path: '/products', label: 'Categories', subLinks: [
        { path: '/products', label: 'All Products' },
        { path: '/women', label: 'Women' },
        { path: '/men', label: 'Men' },
        { path: '/kids', label: 'Kids' },
        { path: '/toys', label: 'Toys' },
        { path: '/beauty', label: 'Beauty' }
      ]
    },
    { path: '/products', label: 'All Products' },

    // { path: '/women', label: 'Women' },
    // { path: '/men', label: 'Men' },
    // { path: '/kids', label: 'Kids' },
    // { path: '/toys', label: 'Toys' },
    // { path: '/beauty', label: 'Beauty' },
    { path: '/jewellery', label: 'Jewellery' },
    { path: '/best-seller', label: 'Best Seller' },
    // { path: '/contact', label: 'Contact' },
  ];
  const navLinksMobile = [
    { path: '/best-seller', label: 'Best Seller' },
    { path: '/women', label: 'Women' },
    { path: '/men', label: 'Men' },
    { path: '/kids', label: 'Kids' },
    { path: '/toys', label: 'Toys' },
    { path: '/beauty', label: 'Beauty' }
  ];

  // Calculate total items and amount dynamically
  const totalAmount = cartItems?.reduce((total, item) => total + item.product?.price * item.quantity, 0);
  const totalItems = cartItems?.reduce((total, item) => total + item.quantity, 0);


  // Remove item from cart (dummy function for now)
  const handleRemoveItem = (id) => {
    if (process.env.NODE_ENV === "development") {
      console.log(`Remove item with id: ${id}`);
    }
    dispatch(removeItemFromCart(id)); // ✅ Remove item from Redux cart
  };



  return (
    <>
      <Navbar expand="lg" className="mb-3 bg-body-tertiary custom-navbar-parent" fixed="top">
        <div className="notification">
          <p>🕉️ Summer Sale Live| Hurry Up!🥳</p>
        </div>
        <Container fluid className="custom-container-header">
          <Navbar.Toggle aria-controls="offcanvasNavbar" className="p-0 bg-transparent border-0 fs-20 fw-bold">
          </Navbar.Toggle>
          <Navbar.Brand as={Link} to="/" className="fw-bold d-none2 d-sm-inline2">
            <span className="logo">
              <i>A</i>
              <i>V</i>
            </span>
          </Navbar.Brand>
          {window.location.pathname === "/cart" || window.location.pathname === "/address" ? <CheckoutSteps currentStep={0} /> :
            <>
              <Navbar.Offcanvas
                id="offcanvasNavbar"
                aria-labelledby="offcanvasNavbarLabel"
                placement="end"
                className="w-100"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel">
                    <p className="mb-0 fw-semibold fs-6">Welcome <span style={{ color: "orangered" }} >{user?.name}</span></p>
                    <p className="mb-0 fw-semibold fs-6">{user?.whatsappNumber}</p>
                  </Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body className="custom-offcanvas-body">
                  <hr />
                  <Nav className="custom-links custom-dropdown-left">
                    {navLinks.map((link) => (
                      link.subLinks ? (
                        <NavDropdown title={link.label} id={`nav-dropdown-${link.label}`} key={link.path} className="me-3 fw-semibold">
                          {link.subLinks.map((subLink) => (
                            <NavDropdown.Item
                              as={NavLink}
                              to={subLink.path}
                              key={subLink.path}
                              className="text-black"
                            >
                              {subLink.label}
                            </NavDropdown.Item>
                          ))}
                        </NavDropdown>
                      ) : (
                        <Nav.Link
                          as={NavLink}
                          to={link.path}
                          key={link.path}
                          className="text-black me-3 text-nowrap fw-semibold"
                        >
                          {link.label}
                        </Nav.Link>
                      )
                    ))}
                  </Nav>
                </Offcanvas.Body>

              </Navbar.Offcanvas>
              <Form className="d-flex custom-search" onSubmit={handleSearchSumbit}>
                <InputGroup>
                  <Form.Control
                    type="search"
                    placeholder="Search for Toy, Necklace, Bracelet, Earrings etc."
                    aria-label="Search"

                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <InputGroup.Text className="bg-white">
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup>
              </Form>
              {/* Profile Dropdown */}
              <NavDropdown
                title={<><FaUserCircle className="me-2" />
                  <span className="text-black fw-semibold d-none d-md-block" style={{ fontSize: "10px" }}>PROFILE</span>
                </>}
                id="offcanvasNavbarDropdown"
                align="start"
                aria-label="Profile Options"
                className="custom-dropdown right profile-dropdown"
              >
                <div className="px-3 py-2 text-left">
                  <p className="p-0 m-0"><strong>Hello</strong> {localStorage.getItem("token") && user?.name ? `${user.name}!` : 'Guest'}</p>
                  {localStorage.getItem("token") &&
                    // <p className="p-0 m-0">{user?.whatsappNumber?.slice(3, 13)}</p>
                    <p className="p-0 m-0">{user?.whatsappNumber}</p>
                  }
                </div>
                <NavDropdown.Divider />

                {localStorage.getItem("token") &&
                  <><NavDropdown.Item as={Link} to="/my/order">
                    Orders
                  </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/my/change-password">
                      Change Password
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/settings">
                      Settings
                    </NavDropdown.Item></>}
                <div className="gap-2 px-3 py-1 d-flex justify-content-between align-items-center">
                  {localStorage.getItem("token") ? (
                    <Button variant="primary" size="sm" onClick={handleLogout}>
                      Logout
                    </Button>
                  ) : <Button as={Link} to="/login" variant="primary" size="sm">
                    Login
                  </Button>}

                  {!localStorage.getItem("token") && (
                    <Button as={Link} to="/signup" variant="outline-primary" size="sm">
                      Signup
                    </Button>
                  )}
                </div>

              </NavDropdown>

              {/* Cart Dropdown */}
              <NavDropdown
                title={

                  <>
                    <FaShoppingCart className="me-2" />
                    <span className="text-black fw-semibold d-none d-md-block" style={{ fontSize: "10px" }} > CART</span>
                    <Badge bg="danger" className="custom-badge">{totalItems > 0 ? totalItems : ""}</Badge>
                  </>
                }
                id="offcanvasNavbarDropdown"
                align="start"
                aria-label="Cart Options"
                className="custom-dropdown right cart-dropdown"
              // style={{ marginLeft: "10px" }}
              >
                {cartItems?.length > 0 ? (
                  <>
                    <ListGroup variant="flush">
                      {cartItems?.map((item) => (
                        <ListGroup.Item key={item._id} className="d-flex align-items-center">
                          <Image src={`${apiUrl}${item.product?.images[0]}`} rounded className="me-3" width={40} height={40} />
                          <div className="flex-grow-1">
                            <div className="fw-bold">{item.product?.name}</div>
                            <div>
                              {item.quantity} x ₹{item.product?.price} = ₹{item.quantity * item.product?.price}
                            </div>
                          </div>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleRemoveItem(item.product._id)}
                            className="ms-3"
                          >
                            <FaTrashAlt />
                          </Button>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>

                    {/* Total Amount & Actions */}
                    <div className="p-3">
                      <div className="mb-2 fw-bold">Total: ₹{totalAmount}</div>
                      <div className="gap-2 d-grid">
                        <Button as={Link} to="/cart" variant="primary" size="sm">
                          View Cart
                        </Button>
                        <Button as={Link} to="/checkout" variant="success" size="sm">
                          Checkout
                        </Button>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="p-3 text-center">
                    Your cart is empty
                    <div className="mt-2">
                      <Button as={Link} to="/" variant="outline-primary" size="sm">
                        Continue Shopping
                      </Button>
                    </div>
                  </div>
                )}
              </NavDropdown>
            </>
          }

        </Container >

        <ul className="custom-links-mobile">
          {navLinksMobile.map((link, index) => (
            <li key={link.path}>
              <Link href={link} active={true} to={link.path} className="text-black me-3 text-nowrap fw-semibold" key={link.path + index}>
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

      </Navbar >


    </>
  );
};

export default Header;